import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LookupService } from '../services/lookup.service';
import { SingleResultApiResponse } from '../models/api-response.model';
import { Subscription, forkJoin } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'online-app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  constructor(private fb: FormBuilder,
    private lookupService: LookupService,
    private renderer: Renderer2) {
    this.renderer.addClass(document.body, 'login-screen');
  }


  loginFormGroup: FormGroup;
  isFormSubmitted = false;
  loginErrorMessage = '';

  showNotification: boolean = true;
  notificationMessage: string;
  isPhase1Decommissioned: boolean = true;
  phase2Url: string = '';

  private subscriptionsToDispose: Subscription[] = [];

  isLoading: boolean = true;

  ngOnInit() {

    // Auth.configure(AuthConfig);


    this.subscriptionsToDispose.push(
      forkJoin([
        this.lookupService.getNotificationSettings(1)
          .pipe(tap((response: SingleResultApiResponse) => {
              if (response.Result) {
                this.showNotification = response.Result.Item1;
                this.notificationMessage = response.Result.Item2;
                this.isPhase1Decommissioned = response.Result.Item3;
                this.phase2Url = response.Result.Item4;
              }
            })
          ),      
      ]).subscribe(() => {
        this.isLoading = false;
      }, (err) => {
        this.isLoading = false;
        console.log(err);
      })
    );

    this.loginFormGroup = this.fb.group({
      loginId: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  ngOnDestroy() {
    this.subscriptionsToDispose.forEach(s => s.unsubscribe());
    this.renderer.removeClass(document.body, 'login-screen');
  }

  login() {}
}
